"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var SnackbarContent = core_1.SnackbarContent;
exports.default = SnackbarContent;
//# sourceMappingURL=SnackbarContent.js.map